/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../../../../core/components';
import { Component, Input } from '@angular/core';
import { ModalService, UserService } from '../../../../../core/services';

@Component({
    selector: 'app-lb-logged-in-user',
    templateUrl: './loggedInUser.component.html',
    styleUrls: ['./loggedInUser.component.scss']
})

export class LoggedInUserComponent extends BaseComponent {
    /**
     * Open state of dropdown
     */
    @Input() set forceOpen(state) {
        this._forceOpen = state;
    }

    /**
     * Option to hide title.
     */
    @Input() set hideTitle(state) {
        this._hideTitle = state;
    }

    /**
     * Set the title alignment externally.
     */
    @Input() public titleAlignment: 'left' | 'centre' | 'right' = 'centre';

    /**
     * Dropdown open state
     * @private
     */
    private _forceOpen: boolean = false;

    /**
     * To store the logged-in username.
     */
    public loggedInUsername: string = '';

    /**
     * Class copy of hide title state.
     * @private
     */
    private _hideTitle: boolean = false;

    constructor(
        public modalService: ModalService,
        public userService: UserService,
    ) {
        super();

        // Get user from local storage not the user service
        this.loggedInUsername = JSON.parse(localStorage.getItem('lbUser')).name;
    }

    /**
     * getForceOpen
     */
    get forceOpen(): any {
        return this._forceOpen;
    }

    /**
     * getForceOpen
     */
    get hideTitle(): any {
        return this._hideTitle;
    }
}
